import React from "react";
import styles from "./index.module.scss";
import { alphabetArray } from "../../../../Utils/alphabet";

const Question = ({ question }) => {
  if (!question) return <div/>

  const getTypeTitle = (type) => {
    switch (type) {
      case 'VF':
        return "Verdadeiro ou Falso";
      case 'ME':
        return "Multipla Escolha";
      default:
        return ""
    }
  }
  const getRespTitle = (resp) => {
    if (question?.alternativas[resp]) {
      return question?.alternativas[resp]
    }

    return ""
  }

  return (
    <div className={styles['container']}>
      <p className={styles['title']}>{question?.assunto}</p>
      <div className={styles['body']}>
        <ul className={styles['details']}>
          <li title={question?.codigo}>{
            question?.codigo?.indexOf('-') > -1
            ?
            `${question?.codigo?.split('-')[1].substr(0, 13)}...`
            :
            question?.codigo
          }</li>
          <li title={getTypeTitle(question?.tipo)}>{question?.tipo}</li>
          <li>{question?.banca}</li>
          {!isNaN(question?.ano) && <li>{question?.ano}</li>}
          <li>{question?.orgao}</li>
          <li>{question?.prova}</li>
          <li>{question?.materia}</li>
          <li className="text-uppercase" title={getRespTitle(question?.respostaCorreta)}>
            Resp: {alphabetArray[question?.respostaCorreta]}
          </li>
          <li></li>
        </ul>
        <div className={styles["question-box"]}>
          <p>{question?.enunciado}</p>
          { question.afirmacao && (
            <div>
              <p>{question?.afirmacao}</p>
            </div>
          )}
          <ul>
            {Array.isArray(question?.alternativas) &&
              question?.alternativas.map((alternativa, index) => (
                <li key={index}>
                  <span>{alphabetArray[index]}</span>
                  <p>{alternativa}</p>
                </li>
              ))}
          </ul>
        </div>
        <div className={styles['comment-container']}>
          <div className={styles['comment-box']}>
            <p className={styles['comment-comment']}>{question.comentario}</p>
          </div>
          <p>{question.autorComentario}</p>
        </div>
      </div>
    </div>
  )
}

export default Question
